import { Account } from '@hcs/types';
import { AuthHeaderFn } from '@hcs/types';

import { queryClient } from '../clients';
import { ACCOUNT_QUERY_KEY } from '../constants';

export const authHeaderFnJwt: AuthHeaderFn = (token: string | null) => {
  if (token) {
    return { authorization: `JWT ${token}` };
  }
  return undefined;
};

export const authHeaderFnAccountApi: AuthHeaderFn = (token: string | null) => {
  if (token) {
    return {
      Authorization: `Bearer ${token}`,
    };
  }
  return undefined;
};

export const authHeaderFnEhrmantraut: AuthHeaderFn = (token: string | null) => {
  if (token) {
    return {
      'HC-API-Auth': `Bearer ${token || ''}`,
    };
  }
  return undefined;
};

export const getHcAuthPrincipals = () => {
  const account = queryClient.getQueryData<Account>([ACCOUNT_QUERY_KEY]);
  return {
    'HC-Auth-Principals': [
      `Organization=${account?.organization.id}`,
      `User=${account?.user.id}`,
    ].join('&'),
  };
};

export const getHcAuthHeader = () => {
  return authHeaderFnEhrmantraut(
    queryClient.getQueryData<Account>([ACCOUNT_QUERY_KEY])?.token?.access ||
      null,
  );
};
